export default {"src":"/_next/static/media/close_white.e3ce0ac7.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};